import { TokenPriceChart } from '@store:web/components/common/TokenPriceChart';

export const PredictionChart = () => {
  return (
    <div className="h-[444px] w-full max-w-[1028px]">
      <TokenPriceChart tokenIdOrSlug="binancecoin" />
    </div>
  );
};
